import { useEffect, useState } from "react";
import { Building2, Calendar, CheckCircle, File, Globe, Loader2, Shield, Users, Zap } from "lucide-react";

interface LoadingSplashProps {
  title?: string;
  subtitle?: string;
  intervalMs?: number;
}

export function LoadingSplash({ title = "Loading…", subtitle, intervalMs = 1100 }: LoadingSplashProps) {
  const tips: Array<{ text: string; Icon: any }> = [
    { text: "Syncing policy registry…", Icon: File },
    { text: "Fetching company profile…", Icon: Building2 },
    { text: "Warming up AI endpoints…", Icon: Zap },
    { text: "Verifying permissions & roles…", Icon: Shield },
    { text: "Collecting department data…", Icon: Users },
    { text: "Scheduling compliance reminders…", Icon: Calendar },
    { text: "Calibrating governance settings…", Icon: Globe },
    { text: "Almost there…", Icon: CheckCircle },
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % tips.length);
    }, intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  const ActiveIcon = tips[index].Icon;

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="text-center space-y-4">
        <div className="flex items-center justify-center gap-3 text-muted-foreground">
          <Loader2 className="h-6 w-6 animate-spin text-primary" />
          <span className="font-medium">{title}</span>
        </div>
        <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
          <ActiveIcon className="w-4 h-4" />
          <span>{tips[index].text}</span>
        </div>
        {subtitle && (
          <p className="text-xs text-muted-foreground/80">{subtitle}</p>
        )}
      </div>
    </div>
  );
}

export default LoadingSplash;


